<template>
	<article class="question" v-if="question">
		<div class="site-wrapper rythm-v">
			<header class="page-header">
				<h1>{{ question.title }}</h1>
			</header>

			<section class="section--question rythm-v">
				<header>
					<h2 class="question-type">{{ typeCaption[question.type] }}</h2>
					<span :class="`tag--${question.status}`">{{ statusCaption[question.status] }}</span>
				</header>

				<div class="toolbar">
					<router-link to="/dashboard" class="button--outline">
						<svg role="img" class="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
							<path
								fill="currentColor"
								d="M7.29289 15.7071C7.68342 16.0976 8.31658 16.0976 8.70711 15.7071C9.09763 15.3166 9.09763 14.6834 8.70711 14.2929L3.41421 9L15 9C15.5523 9 16 8.55229 16 8C16 7.44772 15.5523 7 15 7L3.41421 7L8.70711 1.70711C9.09763 1.31658 9.09763 0.683418 8.70711 0.292894C8.31658 -0.0976312 7.68342 -0.0976312 7.29289 0.292894L0.292894 7.29289C-0.0976312 7.68342 -0.0976312 8.31658 0.292894 8.70711L7.29289 15.7071Z"
							/>
						</svg>
						<span class="caption">Retour</span></router-link
					>

					<button
						v-if="question.status !== 'complete' && this.answers.length && !user_is_expert && !user_is_coordinator"
						type="button"
						class="button--primary"
						@click="completeQuestion"
					>
					<svg
						class="icon icon-check"
						role="img"
						xmlns="http://www.w3.org/2000/svg"
						width="18"
						height="13"
						fill="none"
						viewBox="0 0 18 13"
					>
						<path
							fill="currentColor"
							fill-rule="evenodd"
							d="M17.7071 0.292893C18.0976 0.683417 18.0976 1.31658 17.7071 1.70711L6.70711 12.7071C6.31658 13.0976 5.68342 13.0976 5.29289 12.7071L0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289C0.683417 5.90237 1.31658 5.90237 1.70711 6.29289L6 10.5858L16.2929 0.292893C16.6834 -0.0976311 17.3166 -0.0976311 17.7071 0.292893Z"
							clip-rule="evenodd"
						/>
					</svg>
						<span class="caption">Clore la question</span>
					</button>

					<!--
					<button
						type="button"
						class="button--primary"
						v-if="question.status === 'draft'"
						@click="publishQuestion()"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="22"
							height="16"
							fill="currentColor"
							role="img"
							class="icon"
							viewBox="0 0 22 16"
						>
							<path
								fill-rule="evenodd"
								d="M11 6C10.4696 6 9.96086 6.21071 9.58579 6.58579C9.21071 6.96086 9 7.46957 9 8C9 8.53043 9.21071 9.03914 9.58579 9.41421C9.96086 9.78929 10.4696 10 11 10C11.5304 10 12.0391 9.78929 12.4142 9.41421C12.7893 9.03914 13 8.53043 13 8C13 7.46957 12.7893 6.96086 12.4142 6.58579C12.0391 6.21071 11.5304 6 11 6ZM8.17157 5.17157C8.92172 4.42143 9.93913 4 11 4C12.0609 4 13.0783 4.42143 13.8284 5.17157C14.5786 5.92172 15 6.93913 15 8C15 9.06087 14.5786 10.0783 13.8284 10.8284C13.0783 11.5786 12.0609 12 11 12C9.93913 12 8.92172 11.5786 8.17157 10.8284C7.42143 10.0783 7 9.06087 7 8C7 6.93913 7.42143 5.92172 8.17157 5.17157Z"
								clip-rule="evenodd"
							/>
							<path
								fill-rule="evenodd"
								d="M11.0229 2.34821e-05C11.0153 7.8299e-06 11.0076 0 11 0C6.07374 0 1.90505 3.23851 0.503906 7.7004L0.545827 7.71356C0.48996 7.90043 0.48996 8.09957 0.545827 8.28644L0.503906 8.2996C1.90505 12.7615 6.07374 16 11 16C11.0076 16 11.0153 16 11.0229 16C11.0306 16 11.0383 16 11.0459 16C15.9722 16 20.1408 12.7615 21.542 8.2996L21.5001 8.28644C21.5559 8.09957 21.5559 7.90043 21.5001 7.71356L21.542 7.7004C20.1408 3.23851 15.9722 0 11.0459 0C11.0383 0 11.0306 7.83449e-06 11.0229 2.34821e-05ZM11.023 2.00003C7.11521 2.0098 3.79098 4.51038 2.55793 8C3.79098 11.4896 7.11521 13.9902 11.023 14C14.9307 13.9902 18.2549 11.4896 19.488 8C18.2549 4.51038 14.9307 2.0098 11.023 2.00003Z"
								clip-rule="evenodd"
							/>
						</svg>
						<span class="caption">Publier</span>
					</button>
					-->
					<!--
					<button
						class="button--danger"
						type="button"
						@click="deleteQuestion()"
						v-if="question.status === 'draft'"
					>
						<svg
							viewBox="0 0 16 18"
							xmlns="http://www.w3.org/2000/svg"
							width="16"
							height="18"
							fill="currentColor"
							class="icon"
						>
							<path
								fill-rule="evenodd"
								d="M4.96514 0.527208C5.29854 0.189642 5.75073 0 6.22222 0H9.77778C10.2493 0 10.7015 0.189642 11.0349 0.527208C11.3683 0.864773 11.5556 1.32261 11.5556 1.8V3.6H15.1111C15.602 3.6 16 4.00294 16 4.5C16 4.99706 15.602 5.4 15.1111 5.4H15.0499L14.3382 15.4917C14.2903 16.1728 13.9892 16.8104 13.4957 17.2758C13.0021 17.7413 12.3527 18 11.6782 18H4.3218C3.64732 18 2.99789 17.7413 2.50431 17.2758C2.01079 16.8104 1.70975 16.173 1.66181 15.4919L0.950097 5.4H0.888889C0.397969 5.4 0 4.99706 0 4.5C0 4.00294 0.397969 3.6 0.888889 3.6H4.44444V1.8C4.44444 1.32261 4.63175 0.864773 4.96514 0.527208ZM6.22222 3.6H9.77778V1.8H6.22222V3.6ZM2.7324 5.4L3.43508 15.3637C3.45104 15.5908 3.5514 15.8035 3.71593 15.9586C3.88045 16.1138 4.09693 16.2 4.32178 16.2H11.6782C11.9031 16.2 12.1195 16.1138 12.2841 15.9586C12.4486 15.8035 12.5489 15.591 12.5649 15.3639L13.2676 5.4H2.7324ZM6.22222 7.2C6.71314 7.2 7.11111 7.60294 7.11111 8.1V13.5C7.11111 13.9971 6.71314 14.4 6.22222 14.4C5.7313 14.4 5.33333 13.9971 5.33333 13.5V8.1C5.33333 7.60294 5.7313 7.2 6.22222 7.2ZM9.77778 7.2C10.2687 7.2 10.6667 7.60294 10.6667 8.1V13.5C10.6667 13.9971 10.2687 14.4 9.77778 14.4C9.28686 14.4 8.88889 13.9971 8.88889 13.5V8.1C8.88889 7.60294 9.28686 7.2 9.77778 7.2Z"
								clip-rule="evenodd"
							/>
						</svg>
						<span class="caption">Supprimer</span>
					</button>
					-->
				</div>

				<section class="section--question-details">
					<div class="card shadow rythm-v">
						<header>
							<h3>Détails de la question</h3>
						</header>

						<p v-if="question.details" v-html="question.details"></p>

						<ul class="question-themes--primary list-inline" v-if="question.primary_themes.length">
							<li v-for="theme in question.primary_themes" :key="theme.id" :class="themeClass(theme)">
								{{ theme.name }}
							</li>
							<li v-if="question.primary_other_theme" class="tag--theme-other">{{ question.primary_other_theme }}</li>
						</ul>

						<ul class="question-themes--secondary list-inline" v-if="question.secondary_themes.length">
							<li v-for="theme in question.secondary_themes" :key="theme.id" :class="themeClass(theme)">
								{{ theme.name }}
							</li>
							<li v-if="question.secondary_other_theme" class="tag--theme-other">
								{{ question.secondary_other_theme }}
							</li>
						</ul>

						<section class="section--documents" v-if="question.documents.length">
							<h4>Documents</h4>

							<ul>
								<li v-for="doc in question.documents" :key="doc.id">
									<a :href="`${API_URL}/file/${doc.hash}?jwt=${userToken}`" target="_blank" rel="noreferrer">{{
										doc.filename
									}}</a>
								</li>
							</ul>
						</section>
					</div>
				</section>

				<section class="section--reponse-details">
					<div class="card shadow rythm-v">
						<header>
							<h3>Réponse de l'expert</h3>
						</header>

						<div class="answer-details flex-row">
							<div class="grades">
								<p class="label">Évaluation de la réponse&nbsp;:</p>

								<ul class="reference-level">
									<li class="flex-row flex-center-v">
										<span class="caption">Grade de preuve (EBM) :</span>
										<div>
											<span
												v-if="question.ebm_proof_grade"
												:class="`tag--grade-${question.ebm_proof_grade.toLowerCase()}`"
												>{{ question.ebm_proof_grade }}</span
											>
											<span class="tag" v-else>Indéfini</span>
										</div>
									</li>

									<li class="flex-row flex-center-v">
										<span class="caption">Niveau de recommandation :</span>
										<div>
											<span
												v-if="question.recommendation_level"
												:class="`tag--recommendation-${question.recommendation_level.toLowerCase()}`"
												>{{ recommendationLevelCaption[question.recommendation_level] }}</span
											>
											<span class="tag" v-else>Indéfini</span>
										</div>
									</li>
								</ul>

								<p>
									<em>
										Pour le niveau de preuve et gradation des recommandations<br />de bonne pratique
										<a
											href="https://www.has-sante.fr/upload/docs/application/pdf/2013-06/etat_des_lieux_niveau_preuve_gradation.pdf"
											target="_blank"
											rel="noreferrer"
											class="button--link"
										>
											<span class="caption">Consulter les recommandations de la H.A.S.</span>
											<svg
												role="img"
												class="icon icon-external"
												xmlns="http://www.w3.org/2000/svg"
												width="20"
												height="20"
												fill="none"
												viewBox="0 0 20 20"
											>
												<path
													fill="currentColor"
													fill-rule="evenodd"
													d="M3 5C2.73478 5 2.48043 5.10536 2.29289 5.29289 2.10536 5.48043 2 5.73478 2 6V17C2 17.2652 2.10536 17.5196 2.29289 17.7071 2.48043 17.8946 2.73478 18 3 18H14C14.2652 18 14.5196 17.8946 14.7071 17.7071 14.8946 17.5196 15 17.2652 15 17V11C15 10.4477 15.4477 10 16 10 16.5523 10 17 10.4477 17 11V17C17 17.7957 16.6839 18.5587 16.1213 19.1213 15.5587 19.6839 14.7957 20 14 20H3C2.20435 20 1.44129 19.6839.87868 19.1213.31607 18.5587 0 17.7956 0 17V6C0 5.20435.31607 4.44129.87868 3.87868 1.44129 3.31607 2.20435 3 3 3H9C9.55229 3 10 3.44772 10 4 10 4.55228 9.55229 5 9 5H3zM12 1C12 .447715 12.4477 2.98023e-8 13 2.98023e-8H19C19.5523 2.98023e-8 20 .447715 20 1V7C20 7.55228 19.5523 8 19 8 18.4477 8 18 7.55228 18 7V2H13C12.4477 2 12 1.55228 12 1z"
													clip-rule="evenodd"
												/>
												<path
													fill="currentColor"
													fill-rule="evenodd"
													d="M19.7071 0.292893C20.0976 0.683417 20.0976 1.31658 19.7071 1.70711L8.70711 12.7071C8.31658 13.0976 7.68342 13.0976 7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929L18.2929 0.292893C18.6834 -0.0976311 19.3166 -0.0976311 19.7071 0.292893Z"
													clip-rule="evenodd"
												/></svg
										></a>
									</em>
								</p>
							</div>

							<div class="reference">
								<p class="label">Référence&nbsp;:</p>
								<p v-if="!question.reference"><em>Aucune référence pour le moment.</em></p>
								<p v-else>
									<a class="button--outline" :href="question.reference.url" target="_blank" rel="noreferrer">
										<svg
											role="img"
											class="icon icon-file"
											xmlns="http://www.w3.org/2000/svg"
											width="18"
											height="22"
											fill="none"
											viewBox="0 0 18 22"
										>
											<path
												fill="currentColor"
												fill-rule="evenodd"
												d="M0.87868 0.87868C1.44129 0.31607 2.20435 0 3 0H11C11.2652 0 11.5196 0.105357 11.7071 0.292893L17.7071 6.29289C17.8946 6.48043 18 6.73478 18 7V19C18 19.7957 17.6839 20.5587 17.1213 21.1213C16.5587 21.6839 15.7957 22 15 22H3C2.20435 22 1.44129 21.6839 0.87868 21.1213C0.31607 20.5587 0 19.7957 0 19V3C0 2.20435 0.31607 1.44129 0.87868 0.87868ZM3 2C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V19C2 19.2652 2.10536 19.5196 2.29289 19.7071C2.48043 19.8946 2.73478 20 3 20H15C15.2652 20 15.5196 19.8946 15.7071 19.7071C15.8946 19.5196 16 19.2652 16 19V7.41421L10.5858 2H3Z"
												clip-rule="evenodd"
											/>
											<path
												fill="currentColor"
												fill-rule="evenodd"
												d="M11 0C11.5523 0 12 .447715 12 1V6H17C17.5523 6 18 6.44772 18 7 18 7.55228 17.5523 8 17 8H11C10.4477 8 10 7.55228 10 7V1C10 .447715 10.4477 0 11 0zM4 12C4 11.4477 4.44772 11 5 11H13C13.5523 11 14 11.4477 14 12 14 12.5523 13.5523 13 13 13H5C4.44772 13 4 12.5523 4 12zM4 16C4 15.4477 4.44772 15 5 15H13C13.5523 15 14 15.4477 14 16 14 16.5523 13.5523 17 13 17H5C4.44772 17 4 16.5523 4 16zM4 8C4 7.44772 4.44772 7 5 7H7C7.55228 7 8 7.44772 8 8 8 8.55228 7.55228 9 7 9H5C4.44772 9 4 8.55228 4 8z"
												clip-rule="evenodd"
											/>
										</svg>
										<span class="caption">{{ question.reference.title }}</span>
									</a>
								</p>
							</div>
						</div>
					</div>
				</section>

				<section class="section--expert-chat">
					<div class="card shadow rythm-v">
						<header>
							<h3 v-if="!user_is_expert && !user_is_coordinator">Dialogue avec l'expert</h3>
							<h3 v-else>Dialogue avec le médecin</h3>
						</header>

						<answers-chat
							v-if="answers.length"
							class="section--chat-history"
							:user="user"
							:question="question"
							:answers="answers"
						></answers-chat>

						<p v-else>
							<em v-if="user_is_assigned">Le médecin est en attente de votre réponse.</em>
							<em v-else>En attente d'une réponse de l'expert.</em>
						</p>
					</div>
				</section>

				<div class="question-response card shadow" v-if="isEditable">
					<form @submit.prevent="sendAnswer">
						<div class="fieldset">
							<div class="input-group">
								<label for="answer">Votre réponse :</label>
								<textarea
									aria-labelledby="answer-label"
									name="answer"
									id="answer"
									cols="30"
									rows="6"
									v-model="responseData.answerText"
									required
								></textarea>
							</div>
						</div>

						<div class="question-controls input-group--inline-controls flex-row flex-align-right">
							<div class="button--file-upload" v-if="isEditable && (user_is_expert || user_is_coordinator)">
								<svg
									role="img"
									class="icon icon-upload"
									xmlns="http://www.w3.org/2000/svg"
									width="20"
									height="20"
									fill="none"
									viewBox="0 0 20 20"
								>
									<path
										fill="currentColor"
										fill-rule="evenodd"
										d="M1 12C1.55228 12 2 12.4477 2 13V17C2 17.2652 2.10536 17.5196 2.29289 17.7071 2.48043 17.8946 2.73478 18 3 18H17C17.2652 18 17.5196 17.8946 17.7071 17.7071 17.8946 17.5196 18 17.2652 18 17V13C18 12.4477 18.4477 12 19 12 19.5523 12 20 12.4477 20 13V17C20 17.7957 19.6839 18.5587 19.1213 19.1213 18.5587 19.6839 17.7957 20 17 20H3C2.20435 20 1.44129 19.6839.87868 19.1213.31607 18.5587 0 17.7956 0 17V13C0 12.4477.447715 12 1 12zM9.29289.292893C9.68342-.0976311 10.3166-.0976311 10.7071.292893L15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711 15.3166 7.09763 14.6834 7.09763 14.2929 6.70711L10 2.41421 5.70711 6.70711C5.31658 7.09763 4.68342 7.09763 4.29289 6.70711 3.90237 6.31658 3.90237 5.68342 4.29289 5.29289L9.29289.292893z"
										clip-rule="evenodd"
									/>
									<path
										fill="currentColor"
										fill-rule="evenodd"
										d="M10 2.98023e-08C10.5523 2.98023e-08 11 0.447715 11 1V13C11 13.5523 10.5523 14 10 14C9.44772 14 9 13.5523 9 13V1C9 0.447715 9.44772 2.98023e-08 10 2.98023e-08Z"
										clip-rule="evenodd"
									/>
								</svg>

								<label class="caption">
									<span v-if="!responseData.refFilename">AJOUTER UNE RÉFÉRENCE</span>
									<span v-else>Réf.&nbsp;:&nbsp;{{ responseData.refFilename }}</span>
									<input type="file" name="ref" ref="ref" accept="application/pdf" @change="setRefFile" />
								</label>
							</div>

							<button
								v-if="isEditable && (user_is_expert || user_is_coordinator)"
								type="button"
								class="button--secondary"
								@click="showExpertResponseDetails"
							>
								<svg
									role="img"
									class="icon icon-checkbox"
									xmlns="http://www.w3.org/2000/svg"
									width="21"
									height="20"
									fill="none"
									viewBox="0 0 21 20"
								>
									<path
										fill="currentColor"
										fill-rule="evenodd"
										d="M20.7071 1.29289C21.0976 1.68342 21.0976 2.31658 20.7071 2.70711L10.7071 12.7071C10.3166 13.0976 9.68342 13.0976 9.29289 12.7071L6.29289 9.70711C5.90237 9.31658 5.90237 8.68342 6.29289 8.29289C6.68342 7.90237 7.31658 7.90237 7.70711 8.29289L10 10.5858L19.2929 1.29289C19.6834 0.902369 20.3166 0.902369 20.7071 1.29289Z"
										clip-rule="evenodd"
									/>
									<path
										fill="currentColor"
										fill-rule="evenodd"
										d="M3 2C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V17C2 17.2652 2.10536 17.5196 2.29289 17.7071C2.48043 17.8946 2.73478 18 3 18H17C17.2652 18 17.5196 17.8946 17.7071 17.7071C17.8946 17.5196 18 17.2652 18 17V10C18 9.44771 18.4477 9 19 9C19.5523 9 20 9.44771 20 10V17C20 17.7957 19.6839 18.5587 19.1213 19.1213C18.5587 19.6839 17.7957 20 17 20H3C2.20435 20 1.44129 19.6839 0.87868 19.1213C0.31607 18.5587 0 17.7957 0 17V3C0 2.20435 0.31607 1.44129 0.87868 0.87868C1.44129 0.31607 2.20435 0 3 0H14C14.5523 0 15 0.447715 15 1C15 1.55228 14.5523 2 14 2H3Z"
										clip-rule="evenodd"
									/>
								</svg>

								<span class="caption">Évaluer la réponse</span>
							</button>

							<button
								v-if="isEditable && (user_is_expert || user_is_coordinator)"
								type="submit"
								class="button--primary"
							>
								<svg
									role="img"
									xmlns="http://www.w3.org/2000/svg"
									width="22"
									height="22"
									fill="none"
									viewBox="0 0 22 22"
									class="icon"
								>
									<path
										fill="currentColor"
										fill-rule="evenodd"
										d="M21.7071 0.292921C22.0976 0.683445 22.0976 1.31661 21.7071 1.70713L10.7071 12.7071C10.3166 13.0977 9.68342 13.0977 9.2929 12.7071C8.90237 12.3166 8.90237 11.6834 9.2929 11.2929L20.2929 0.292921C20.6834 -0.0976032 21.3166 -0.0976032 21.7071 0.292921Z"
										clip-rule="evenodd"
									></path>
									<path
										fill="currentColor"
										fill-rule="evenodd"
										d="M21.7071 0.292921C21.9787 0.564559 22.0708 0.967791 21.9439 1.33038L14.9439 21.3304C14.8084 21.7174 14.4504 21.9825 14.0408 21.9992C13.6311 22.0159 13.2527 21.7808 13.0862 21.4062L9.2424 12.7576L0.593867 8.91384C0.219186 8.74731 -0.0158775 8.36894 0.000836285 7.95926C0.0175501 7.54959 0.282654 7.19162 0.669655 7.05617L20.6697 0.0561695C21.0322 -0.0707359 21.4355 0.0212832 21.7071 0.292921ZM3.71108 8.11063L10.4061 11.0862C10.6324 11.1868 10.8133 11.3677 10.9138 11.5939L13.8894 18.289L19.37 2.63L3.71108 8.11063Z"
										clip-rule="evenodd"
									></path>
								</svg>
								<span class="caption">Répondre au médecin</span>
							</button>

							<button
								v-if="isEditable && !user_is_expert && !user_is_coordinator"
								type="submit"
								class="button--primary"
							>
								<svg
									role="img"
									xmlns="http://www.w3.org/2000/svg"
									width="22"
									height="22"
									fill="none"
									viewBox="0 0 22 22"
									class="icon"
								>
									<path
										fill="currentColor"
										fill-rule="evenodd"
										d="M21.7071 0.292921C22.0976 0.683445 22.0976 1.31661 21.7071 1.70713L10.7071 12.7071C10.3166 13.0977 9.68342 13.0977 9.2929 12.7071C8.90237 12.3166 8.90237 11.6834 9.2929 11.2929L20.2929 0.292921C20.6834 -0.0976032 21.3166 -0.0976032 21.7071 0.292921Z"
										clip-rule="evenodd"
									></path>
									<path
										fill="currentColor"
										fill-rule="evenodd"
										d="M21.7071 0.292921C21.9787 0.564559 22.0708 0.967791 21.9439 1.33038L14.9439 21.3304C14.8084 21.7174 14.4504 21.9825 14.0408 21.9992C13.6311 22.0159 13.2527 21.7808 13.0862 21.4062L9.2424 12.7576L0.593867 8.91384C0.219186 8.74731 -0.0158775 8.36894 0.000836285 7.95926C0.0175501 7.54959 0.282654 7.19162 0.669655 7.05617L20.6697 0.0561695C21.0322 -0.0707359 21.4355 0.0212832 21.7071 0.292921ZM3.71108 8.11063L10.4061 11.0862C10.6324 11.1868 10.8133 11.3677 10.9138 11.5939L13.8894 18.289L19.37 2.63L3.71108 8.11063Z"
										clip-rule="evenodd"
									></path>
								</svg>
								<span class="caption">Répondre à l'expert</span>
							</button>
						</div>
					</form>
				</div>
			</section>
		</div>

		<!--
		<expert-response-modal
			v-if="question && isEditable"
			:open="modalExpertResponseVisible"
			:user="user"
			:question="question"
			@modalClose="modalClose"
			@submit="sendAnswer"
		/>
		-->

		<expert-response-details-modal
			v-if="question && isEditable"
			:open="modalExpertResponseDetailsVisible"
			:user="user"
			:question="question"
			@modalClose="modalClose"
			@submit="sendDetails"
		/>
	</article>
</template>

<style lang="scss">
@import "src/scss/question.scss";
@import "src/scss/06-components/components.toolbar";

.chat-message + .chat-message {
	margin-top: 2rem;
}
</style>

<style lang="scss" scoped>
.page-header {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: flex-start;
	justify-content: space-between;

	h1 {
		text-transform: none;
		flex-basis: 70%;
	}
}

.section--reponse-details {
	.grades {
		flex-basis: 50%;
		flex-grow: 0;
	}
	.reference {
		flex-basis: 0;
		flex-grow: 1;
		padding: 0 1rem;
	}

	.button--link .icon {
		margin-left: 0.25em !important;
	}
}

.reference-level {
	margin-top: 1rem;

	[class^="tag"] {
		margin-left: 0.5rem;
	}
}

.section--question > header {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: center;

	.caption + [class^="tag"] {
		margin-left: 1em;
	}
}

.section--chat-history {
	margin-bottom: 2rem;
}

.reference {
	.button--outline {
		text-transform: none;
	}
}

.question-response {
	margin-top: 0 !important;

	.question-controls {
		padding-top: 1rem;

		& [class*="button"] {
			min-width: 210px;
			margin-top: 0 !important;
			margin-left: 1rem;
		}
	}

	.button--file-upload {
		text-transform: none;
		max-width: 300px;
		.caption {
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}
	}
}
</style>

<script>
import {HTTP} from "../http-common.js";
import {slugify} from "../libs/helpers.js";
import AnswersChat from "@/components/AnswersChat";
import expertResponseDetailsModal from "@/components/expertResponseDetailsModal";

// Component
export default {
	name: "Question",
	props: ["questionID"],
	components: {
		AnswersChat,
		expertResponseDetailsModal
	},

	data: function() {
		return {
			API_URL: HTTP.defaults.baseURL,
			userToken: this.$store.state.userToken,
			question: null,
			answers: [],
			modalExpertResponseDetailsVisible: false,

			// Response
			responseData: {
				answerText: "",
				ref: "",
				refFilename: ""
			},

			statusCaption: {
				draft: "Brouillon",
				pending: "En attente de réponse",
				ongoing: "Réponse disponible",
				complete: "Terminé"
			},

			typeCaption: {
				general: "Question générale",
				patient: "Question relative à un patient"
			},

			recommendationLevelCaption: {
				faible: "Faible",
				intermediaire: "Intermédiaire",
				moyen: "Moyen",
				fort: "Fort"
			}
		};
	},

	computed: {
		// Current user data
		user: function() {
			return this.$store.state.userData;
		},

		// Is the user a coordinator? (role 3)
		user_is_coordinator: function() {
			return this.user.roles.indexOf(3) !== -1;
		},

		// Is the user an expert? (role 2)
		user_is_expert: function() {
			return this.user.roles.indexOf(2) !== -1;
		},

		// Is the question assigned to the current user?
		user_is_assigned: function() {
			return this.question.expert_id === this.user.id;
		},

		// Display chat editor
		isEditable: function() {
			// The user IS an expert (or coordinator), the question is assigned to the user and he has not responded yet.
			if (
				(!!this.user_is_expert || !!this.user_is_coordinator) &&
				this.user_is_assigned &&
				this.question.status === "pending"
			)
				return true;

			// The user is NOT an expert and an expert response IS available
			if (!this.user_is_expert && !this.user_is_coordinator && this.question.status === "ongoing") return true;

			return false;
		}
	},

	methods: {
		resetFileInput: function() {
			let fileInput = this.$refs.ref.files[0];
			fileInput.value = "";
		},

		// set ref input file
		setRefFile: function(e) {
			let fileInput = e.target;
			let errors = false;

			if (fileInput.files && fileInput.files[0]) {
				// file type
				if (fileInput.files[0].type !== "application/pdf") {
					this.resetFileInput();
					errors = true;
					this.$toasted.global.app_error({
						message: "Le fichier n'est pas un PDF."
					});
				}

				// file weight
				if (typeof FileReader !== "undefined") {
					let size = fileInput.files[0].size;
					if (size > 20000000) {
						errors = true;
						this.resetFileInput();
						this.$toasted.global.app_error({
							message: "Le poids du fichier ne doit pas dépasser 20 Mo."
						});
					}
				}

				// display filename
				if (!errors) this.responseData.refFilename = fileInput.files[0].name;
			}
		},

		showExpertResponseDetails: function(event) {
			this.modalExpertResponseDetailsVisible = true;
		},

		// close modal
		modalClose: function(event) {
			this.modalExpertResponseDetailsVisible = false;
		},

		// Complete question
		completeQuestion: function() {
			let confirm = window.confirm("Clore cette question ? L'expert ne pourra plus y apporter de réponse.");
			if (!confirm) return;

			// change question status
			let questionID = this.questionID;
			this.$store.dispatch("COMPLETE_QUESTION", this.questionID).then(() => this.$router.go());
		},

		// Grades, reference, …
		sendDetails: function(details) {
			let questionID = this.questionID;
			let payload = {
				ebm_proof_grade: details.ebm_proof_grade,
				recommendation_level: details.recommendation_level
			};

			this.$store
				.dispatch("PUT_ANSWER_DETAILS", {questionID, payload})
				.then(response => {
					// update question status, update answers list
					this.getQuestionData();
					this.modalClose();
				})
				.catch(error => {
					console.log("PUT_ANSWER_DETAILS error…", error);
				});
		},

		// Upload ref
		sendReference: function() {
			let questionID = this.questionID;
			let fileInput = this.$refs.ref && this.$refs.ref.files[0];

			// No file
			if (!fileInput) return;

			let formData = new FormData();
			formData.append("file", fileInput);

			this.$store
				.dispatch("SEND_QUESTION_REFERENCE", {questionID, formData})
				.then(() => {
					this.getQuestionData();
					this.$toasted.global.app_success({
						message: "La référence est enregistrée"
					});
				})
				.catch(error => {
					return this.$toasted.global.app_error({
						message:
							"Une erreur est survenue lors de l'envoi de la référence.<br>Veuillez nous contacter pour résoudre le problème."
					});
				});
		},

		// Post answer and reference
		sendAnswer: function() {
			let questionID = this.questionID;
			let payload = {
				details: this.responseData.answerText
			};

			// Save answer
			this.$store
				.dispatch("POST_ANSWER", {questionID, payload})
				.then(response => {
					this.getQuestionData();
					this.getAnswers();
					this.$toasted.global.app_success({
						message: "Votre réponse est envoyée"
					});
				})
				.catch(error => {
					console.log("POST_ANSWER error…", error);
				});

			// Upload reference
			if (this.user_is_expert || this.user_is_coordinator) this.sendReference();
		},

		// Retrieve chat
		getAnswers: function() {
			this.$store
				.dispatch("GET_ANSWERS", this.questionID)
				.then(answers => {
					this.answers = answers;
				})
				.catch(error => {
					console.log("GET_ANSWERS error…", error);
				});
		},

		// Delete the question
		deleteQuestion: function() {
			let confirm = window.confirm(`Supprimer la question № ${this.questionID} ? \n${this.question.title}`);
			if (!confirm) return;

			this.$store
				.dispatch("DELETE_QUESTION", this.questionID)
				.then(success => {
					if (!success)
						this.$toasted.global.app_error({
							message:
								"<div><strong>Impossible de supprimer la question !</strong><br>Seuls les brouillons peuvent être supprimés.</div>"
						});
					else this.$router.push("/dashboard");
				})
				.catch(error => {
					console.log("DELETE_QUESTION error…", error);
				});
		},

		publishQuestion: function() {
			// TODO: reload status without refresh!
			let confirm = window.confirm(`Publier la question № ${this.questionID} ? \n${this.question.title}`);
			if (!confirm) return;

			this.$store.dispatch("PUBLISH_QUESTION", this.questionID).then(() => this.$router.go());
		},

		getQuestionData: function() {
			this.$store
				.dispatch("GET_QUESTION_DATA", this.questionID)
				.then(response => {
					this.question = response;
				})
				.catch(error => {
					console.log("getQuestionData error…", error);
					// eventHub.$emit("network-error", error.response);
				});
		},

		// set the theme tag classes
		themeClass: function(theme) {
			let classAttr = `tag--theme-${this.slug(theme.name)}`;
			if (parseInt(theme.parent_id) === 0) classAttr = `${classAttr} is-root-theme`;
			return classAttr;
		},

		// Helpers.slugify: Create slug from string
		slug: slugify
	},

	mounted() {
		// Load questions
		if (this.questionID > 0) {
			this.getQuestionData();
			this.getAnswers();
		} else this.$router.push("/dashboard");
	}
};
</script>
